module.exports = __webpack_public_path__ + "static/img/menu-down.34bd6069.svg";